module.exports = __webpack_public_path__ + "static/media/1.566b5ac6.png";